import { findIndex } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { useMobile } from "@krea/customer-features/hooks";
import { Text } from "@krea/customer-features/shared-components/text";
import AppTooltip from "@krea/customer-features/shared-components/tooltip";
import { twMerge } from "@krea/shared/design-system/tailwind-utils";

interface IProgressBarTriageItemProps {
  current: boolean;
  previous: boolean;
  tooltip: string;
  className?: string;
  last?: boolean;
}

const ProgressBarTriageItem = ({
  current,
  previous,
  tooltip,
  className,
  last,
}: IProgressBarTriageItemProps) => {
  return (
    <AppTooltip
      content={tooltip}
      className={twMerge("tw-w-full", { "tw-pr-1": !last })}
    >
      <div
        className={twMerge(
          "tw-w-full tw-relative tw-h-2",
          current || previous ? "tw-bg-primary" : "tw-bg-gray",
          className,
        )}
      />
    </AppTooltip>
  );
};

interface IStep {
  field: string;
  displayName: string;
}

interface IProgressBarTriageProps {
  steps: IStep[];
}

const ProgressBarTriage = ({ steps }: IProgressBarTriageProps) => {
  const { pathname } = useLocation();
  const isMobile = useMobile();
  const { t } = useTranslation();

  const currentIndex = (array: IStep[], field: string) => {
    return findIndex(array, { field: field });
  };

  const currentField = pathname.slice(pathname.lastIndexOf("/") + 1);

  const currentNumber = 1 + currentIndex(steps, currentField);

  const stepsLength = steps.length + 1;

  return (
    <div className="-tw-mt-1 tw-mb-6 tw-overflow-hidden md:tw-mb-8">
      <div className="tw-mb-2 tw-flex tw-justify-between md:tw-mb-3">
        <Text size={!isMobile ? "md" : "sm"}>
          <span className="tw-font-bold">
            {t("iaq.progressBar.steps", {
              currentStep: currentNumber,
              stepsQty: stepsLength - 1,
            })}
          </span>
          &nbsp;
          {t("iaq.progressBar.optional")}
        </Text>
      </div>

      <div className="tw-flex tw-list-none">
        {steps.map((item, index) => (
          <ProgressBarTriageItem
            key={index}
            current={pathname.includes(item.field)}
            tooltip={item.displayName}
            previous={index < currentIndex(steps, currentField)}
          />
        ))}
      </div>
    </div>
  );
};

export default ProgressBarTriage;
